<div class="orange">
  <p>{{ 'new_strategy.special_req.success' | translate }}</p>
</div>
